module.exports = __webpack_public_path__ + "img/Teacher.0762eb40.png";